import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Alert, alertClasses, Box, Snackbar, Typography } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import ErrorCodes from '../../api/errorCodes';
import { toasterTimerError, toasterTimerSuccess } from '../../constants';
import { showNewNotification } from "../../redux/commonSlice";
import { useAppSelector } from "../../store/hooks";
export var NewToasterComponent = function () {
    var _a;
    var dispatch = useDispatch();
    var newNotification = useAppSelector(function (state) { return state.common.newNotification; });
    var safeAreaMargin = useSelector(function (state) { return state.common.safeAreaMargin; });
    var handleClose = function () {
        dispatch(showNewNotification(_objectSpread(_objectSpread({}, newNotification), {}, {
            isOpen: false
        })));
    };
    return newNotification.message ? /*#__PURE__*/ React.createElement(Snackbar, {
        open: newNotification.isOpen,
        autoHideDuration: newNotification.type === 'success' ? toasterTimerSuccess : toasterTimerError,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "right"
        },
        onClose: handleClose,
        sx: {
            zIndex: 9999,
            marginTop: "".concat(safeAreaMargin === null || safeAreaMargin === void 0 ? void 0 : safeAreaMargin.top, "px")
        },
        id: newNotification.type === 'success' ? 'successToast' : 'errorToast'
    }, /*#__PURE__*/ React.createElement(Alert, {
        elevation: 6,
        variant: "filled",
        onClose: handleClose,
        severity: newNotification.type,
        id: newNotification.type === 'success' ? 'successAlert' : 'errorAlert',
        sx: (_a = {
                bgcolor: "".concat(newNotification.type, ".main"),
                color: 'white'
            },
            _a[".".concat(alertClasses.action)] = {
                alignItems: "center"
            },
            _a[".".concat(alertClasses.icon)] = {
                alignItems: "center"
            },
            _a)
    }, /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "sm",
        fontWeight: "strong"
    }, /*#__PURE__*/ React.createElement(ErrorCodes, {
        code: newNotification.title
    })), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "base",
        fontWeight: "normal"
    }, /*#__PURE__*/ React.createElement(ErrorCodes, {
        code: newNotification.message
    }))))) : null;
};
